import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Effect to handle the "Floating" look when the user scrolls
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Helper to highlight the active tab
  const isActive = (path) => location.pathname === path;

  return (
    <nav 
      className={`fixed w-full z-[100] transition-all duration-500 px-6 ${
        isScrolled ? "top-4" : "top-0"
      }`}
    >
      <div 
        className={`max-w-7xl mx-auto transition-all duration-500 flex justify-between items-center overflow-hidden ${
          isScrolled 
          ? "bg-white/80 backdrop-blur-xl shadow-2xl shadow-navy/10 rounded-[2rem] border border-white/20 p-4 px-8" 
          : "bg-transparent py-8 px-4"
        }`}
      >
        {/* Logo Section */}
        <Link to="/" className="flex flex-col group">
          <h1 className={`text-xl font-black tracking-tighter transition-colors duration-300 ${
            isScrolled ? "text-navy" : "text-navy"
          }`}>
            NAZARENE <span className={isScrolled ? "text-logo-teal" : "text-atlantic"}>DISTRICT</span>
          </h1>
          <span className={`text-[8px] font-black uppercase tracking-[0.4em] transition-opacity ${
            isScrolled ? "text-fynbos opacity-60" : "text-fynbos opacity-80"
          }`}>
            Western Cape
          </span>
        </Link>

        {/* Navigation Links */}
        <div className="hidden lg:flex items-center space-x-1">
          {[
            { name: "Home", path: "/" },
            { name: "About", path: "/about" },
            { name: "Churches", path: "/churches" },
            { name: "Ministries", path: "/ministries" },
            { name: "Events", path: "/events" },
            { name: "Calendar", path: "/calendar" },
            { name: "Contact", path: "/contact" },
          ].map((tab) => (
            <Link
              key={tab.name}
              to={tab.path}
              className={`relative px-4 py-2 text-[11px] font-black uppercase tracking-[0.2em] transition-all duration-300 rounded-xl hover:bg-atlantic/10 ${
                isScrolled 
                  ? (isActive(tab.path) ? "text-atlantic" : "text-navy hover:text-atlantic") 
                  : (isActive(tab.path) ? "text-atlantic" : "text-fynbos hover:text-atlantic")
              }`}
            >
              {tab.name}
            </Link>
          ))}
        </div>

        {/* Action Button - The "Give" or "Join" CTA */}
        {/* <Link 
          to="/contact" 
          className={`hidden md:block px-6 py-2.5 rounded-full font-black text-[10px] uppercase tracking-widest transition-all duration-300 ${
            isScrolled 
            ? "bg-navy text-white hover:bg-atlantic shadow-lg" 
            : "bg-white text-navy hover:bg-atlantic hover:text-white"
          }`}
        >
          Get Involved
        </Link> */}

        {/* Mobile Hamburger Button */}
        <button className="lg:hidden flex flex-col justify-center gap-1.5" onClick={() => setMenuOpen(!menuOpen)}>
          <div className={`w-6 h-[2px] transition-all ${menuOpen ? "bg-navy-blue rotate-45 translate-y-2" : "bg-navy-blue"}`}></div>
          <div className={`w-6 h-[2px] transition-all bg-navy-blue ${menuOpen ? "opacity-0" : ""}`}></div>
          <div className={`w-6 h-[2px] transition-all ${menuOpen ? "bg-navy-blue -rotate-45 -translate-y-2" : "bg-navy-blue"}`}></div>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden max-w-7xl mx-auto bg-white/95 backdrop-blur-xl rounded-2xl shadow-xl mt-2 px-6 py-4 flex flex-col gap-2">
          {[
            { name: "Home", path: "/" },
            { name: "About", path: "/about" },
            { name: "Churches", path: "/churches" },
            { name: "Ministries", path: "/ministries" },
            { name: "Events", path: "/events" },
            { name: "Calendar", path: "/calendar" },
            { name: "Contact", path: "/contact" },
          ].map((tab) => (
            <Link
              key={tab.name}
              to={tab.path}
              onClick={() => setMenuOpen(false)}
              className={`px-4 py-2 text-[11px] font-black uppercase tracking-[0.2em] rounded-xl hover:bg-atlantic/10 ${
                isActive(tab.path) ? "text-atlantic" : "text-navy hover:text-atlantic"
              }`}
            >
              {tab.name}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}

